import Component from 'vue-class-component'
import Vue from 'vue'

@Component({
  name: 'reactButton',
  props: ['isEditing']
})
export default class EditButton extends Vue {
  get action () {
    return this.$props['isEditing'] ? 'done' : 'edit'
  }

  get type () {
    return 'fal'
  }

  get icon () {
    return this.$props['isEditing'] ? 'check-square' : 'pen-square'
  }
}
